import React from 'react';
import { useLanguage } from './LanguageContext';

const AppHeader = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <header className="site-header">
      <div>
        <p className="site-kicker">Varberg Surf Spot</p>
        <h1>{language === 'english' ? 'Apelviken Surfspot' : 'Apelviken Surfplats'}</h1>
      </div>

      <button
        className="language-toggle"
        onClick={() => setLanguage((prev) => (prev === 'english' ? 'swedish' : 'english'))}
        aria-label={language === 'english' ? 'Switch to Swedish' : 'Byt till engelska'}
      >
        <img
          src={language === 'english' ? `${process.env.PUBLIC_URL}/static/icons/general/english_icon.png` : `${process.env.PUBLIC_URL}/static/icons/general/swedish_icon.png`}
          alt={language === 'english' ? 'English' : 'Svenska'}
          className="icon-sm"
        />
        <span>{language === 'english' ? 'EN' : 'SV'}</span>
      </button>
    </header>
  );
};

export default AppHeader;
